import type { AllRouteEndpoints } from "../routeTypes";
export const integrationsDirectCdiImportKeysGenerateCacheKeys: AllRouteEndpoints[] = [];
